import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_PERMISSIONS_LIST,
    ADD_NEW_PERMISSION,
    UPDATE_PERMISSION,
    DELETE_PERMISSION,
} from "./actionTypes"

import {
    getPermissionsListSuccess,
    getPermissionsListFail,
    addNewPermissionSuccess,
    addNewPermissionFail,
    updatePermissionSuccess,
    updatePermissionFail,
    deletePermissionSuccess,
    deletePermissionFail,
} from "./actions"

import {
    getPermissionsList,
    addNewPermission,
    updatePermission,
    deletePermission,
} from "../../helpers/fakebackend_helper"

function* fetchPermissions() {
    try {
        const response = yield call(getPermissionsList)
        yield put(getPermissionsListSuccess(response))
    } catch (error) {
        yield put(getPermissionsListFail(error))
    }
}

function* onAddNewPermission({ payload: permission }) {
    try {
        const response = yield call(addNewPermission, permission)
        yield put(addNewPermissionSuccess(response))
    } catch (error) {
        yield put(addNewPermissionFail(error))
    }
}

function* onUpdatePermission({ payload: permission }) {
    try {
        const response = yield call(updatePermission, permission)
        yield put(updatePermissionSuccess(response))
    } catch (error) {
        yield put(updatePermissionFail(error))
    }
}

function* onDeletePermission({ payload: id }) {
    try {
        yield call(deletePermission, id)
        yield put(deletePermissionSuccess(id))
    } catch (error) {
        yield put(deletePermissionFail(error))
    }
}

function* permissionsSaga() {
    yield takeEvery(GET_PERMISSIONS_LIST, fetchPermissions)
    yield takeEvery(ADD_NEW_PERMISSION, onAddNewPermission)
    yield takeEvery(UPDATE_PERMISSION, onUpdatePermission)
    yield takeEvery(DELETE_PERMISSION, onDeletePermission)
}

export default permissionsSaga
